import axios from "axios";
import {
  Toast
} from 'vant';

//let baseURL = 'http://127.0.0.1:8084/'
let baseURL = 'https://ycyz.h5.hscarstop.cn/api/'
const instance = axios.create({
  baseURL: baseURL,
  timeout: 100000
});

instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject({
      msg: error.response && error.response.data ? (error.response.data.msg || error.response.data.message) : '网络错误',
      res: error.response
    });
  }
);

function baseRequest(options) {
  // 默认显示 loading，可以通过 options.loading = false 关闭
  const showLoading = options.loading !== false;
  if (showLoading) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    });
  }
  const token = localStorage.getItem('token');
  const headers = options.headers || {
    'Content-Type': 'application/json',
    'Authorization': token ? ('Bearer ' + token) : ''
  };
  options.headers = headers;
  return instance(options).then(res => {
    if (showLoading) {
      Toast.clear();
    }
    const data = res.data || {};
    if (res.status == 401 || data.code == 401) {
      Toast('登陆过期');
      localStorage.removeItem('token');
      window.location.href = 'https://ycwx.fjnx.com.cn/wechat/meritbox?redirect_url=https://ycyz.h5.hscarstop.cn?state=w';
    }
    if (res.status !== 200) {
      Toast('请求失败');
      return Promise.reject({
        msg: "请求失败",
        res,
        data
      });
    }
    return Promise.resolve(data, res);

  }).catch(e => {
    if (showLoading) {
      Toast.clear();
    }
    if (e && e.res && e.res.status == 401) {
      Toast('登陆过期');
      localStorage.removeItem('token');
      window.location.href = 'https://ycwx.fjnx.com.cn/wechat/meritbox?redirect_url=https://ycyz.h5.hscarstop.cn?state=w';
    }
    if (e && e.res && e.res.status !== 200) {
      Toast('请求失败');
      return Promise.reject(e);
    }
    return Promise.reject(e);
  });
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ["post", "put", "patch"].reduce((request, method) => {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(
      Object.assign({
        url,
        data,
        method
      }, options)
    );
  };
  return request;
}, {});

["get", "delete", "head"].forEach(method => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(
      Object.assign({
        url,
        params,
        method
      }, options)
    );
  };
});

export default request;
